import React, { useEffect, useState } from "react";
import * as _ from "lodash"
import useWindowDimensions from "../../../helpers/useWindowDimensions";
// import { GET_ORDERS } from "../../../graphql/order/query";
import { Button, Form, Spinner } from "react-bootstrap";
import useReactRouter from "use-react-router"
import { useMutation, useLazyQuery } from "@apollo/client";
import { COLOR_APP } from "../../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faEdit, faSearch, faTimesCircle, faSyncAlt} from "@fortawesome/free-solid-svg-icons";
// import { GET_LIVE_STOCKS } from "../../../graphql/liveStock/query";
import Switch from "react-switch";
import { convertCurrency, imageRender } from "../../../helpers";
import { CLEAR_CACHE_LIVE_STOCK_REDIS, CREATE_STOCK_AND_PRODUCT, UPDATE_LIVE_STOCK } from "../../../graphql/liveStock/mutation";
import { UPDATE_STOCK } from "../../../graphql/stock/mutation";
import { GET_STOCKS } from "../../../graphql/stock/query";
import NumberFormat from "react-number-format";
import { useToasts } from "react-toast-notifications";
import AddStockModal from "./AddStockModal";
import Tooltip from "../../../components/Tooltip";
import ReactPaginate from "react-paginate";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";

function StockLiveScreen({ fetchLiveStocks, liveStocks, setLiveStocks, totalLiveStock, seTotalLiveStock }) {
    const thousand = num => num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";
    const { addToast } = useToasts()
    const { height, width } = useWindowDimensions();
    const { history, match } = useReactRouter()

    // State 
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [editStockId, setEditStockId] = useState(null);
    const [price, setPrice] = useState(null);
    const [amount, setAmount] = useState(0);
    const [amountAdd, setAmountAdd] = useState("");
    const [amountRemove, setAmountRemove] = useState("");
    const [oldAmountAll, setOldAmountAll] = useState(0);
    const [searchLiveStocks, setSearchLiveStocks] = useState();
    const [textSearch, setTextSearch] = useState();
    // const [showAddStock, setShowAddStock] = useState(false);
    // const [currency, setCurrency] = useState("ກີບ");
    // const [cfMessage, setCfMessage] = useState("");
    // const [productTital, setProductTital] = useState("");
    // const [stockPriceLak, setStockPriceLak] = useState(null);
    // const [stockAmount, setStockAmount] = useState(null);
    // const [liveProductData, setLiveProductData] = useState([]);
    const [showAddStockModal, setShowAddStockModal] = useState(false);
    const [currentItems, setCurrentItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [orderBy, setOrderBy] = useState("cfMessage_ASC");
    const [showAnalytics, setShowAnalytics] = useState(false); // Analytics toggle state
    const _limit = 100; // Number of items per page

    const [updateLiveStock] = useMutation(UPDATE_LIVE_STOCK)
    const [updateStock] = useMutation(UPDATE_STOCK)
    const [clearCacheLiveStockRedis, { loading: clearCacheLoading }] = useMutation(CLEAR_CACHE_LIVE_STOCK_REDIS);
    const [createStockAndProduct] = useMutation(CREATE_STOCK_AND_PRODUCT)
    const [getStocks, { data: stockData, loading: stockLoading }] = useLazyQuery(GET_STOCKS, { fetchPolicy: "cache-and-network" })

    // Use effect
    useEffect(() => {
        if (liveStocks?.length > 0) handleSearch(textSearch || "");
    }, [JSON.stringify(liveStocks)])

    // Handle orderBy changes
    useEffect(() => {
        if (liveStocks?.length > 0) {
            if (!textSearch || textSearch === "") {
                const sortedStocks = sortLiveStocks(liveStocks, orderBy);
                setSearchLiveStocks(sortedStocks);
            } else {
                const filteredResults = liveStocks.filter((lStock) => {
                    return lStock.cfMessage?.toLowerCase().includes(textSearch.toLowerCase());
                });
                const sortedFilteredResults = sortLiveStocks(filteredResults, orderBy);
                setSearchLiveStocks(sortedFilteredResults);
            }
        }
    }, [orderBy, liveStocks])

    // console.log("currentItems:::-->", currentItems)
    useEffect(() => {
        const startIndex = currentPage * _limit;
        const endIndex = Math.min(startIndex + _limit, searchLiveStocks ? searchLiveStocks?.length : totalLiveStock);
        const _newLiveStocks = (searchLiveStocks ? searchLiveStocks : liveStocks).slice(startIndex, endIndex)
        setCurrentItems(_newLiveStocks);
        // setCurrentItems(liveStocks.slice(0, _limit));
    }, [liveStocks, _limit, currentPage, searchLiveStocks]);

    // Function
    const onEditing = (id, stockId, _price, _amountAll, _amount) => {
        setEditId(id)
        setEditStockId(stockId)
        setPrice(_price)
        setAmountAdd("")
        setAmountRemove("")
        setOldAmountAll(_amountAll)
        setAmount(_amount)
        setIsEditing(true)
        try {
            if (!stockData?.stocks?.data) {
                const SHOP_ID = localStorage.getItem("SHOP");
                getStocks({
                    variables: {
                        where: { isDeleted: false, shop: SHOP_ID },
                        orderBy: "createdAt_DESC",
                        limit: 1000,
                        skip: 0,
                    },
                });
            }
        } catch (e) {}
    }

    const onCancel = () => {
        setEditId(null)
        setEditStockId(null)
        setPrice(null)
        setAmountAdd("")
        setAmountRemove("")
        setOldAmountAll(0)
        setAmount(0)
        setIsEditing(false)
    }

    const onEditLiveStock = async (item) => {
        try {
            const addVal = amountAdd ? parseFloat(amountAdd.toString().replace(/,/g, '')) : 0;
            const removeValRaw = amountRemove ? parseFloat(amountRemove.toString().replace(/,/g, '')) : 0;
            const removeVal = Math.abs(removeValRaw);
            // const currentStock = (stockData?.stocks?.data || []).find((s) => s?.id === item?.stock?.id);
            // const stockAmount = currentStock?.amount ?? item?.stock?.amount ?? 0;
            // const totalAllocatedForStock = (liveStocks || []).reduce((sum, ls) => {
            //     if (ls?.stock?.id === item?.stock?.id) return sum + (ls?.amountAll || 0);
            //     return sum;
            // }, 0);
            // const allowedRemaining = stockAmount - totalAllocatedForStock;
            // if (addVal > 0 && addVal > allowedRemaining) {
            //     addToast("ບໍ່ສາມາດເພີ່ມຈຳນວນເກີນທີ່ມີໃນສະຕ໊ອກໄດ້", { appearance: 'error', autoDismiss: true });
            //     return;
            // }
            let _amount = amount + addVal - removeVal;
            const newAmountAll = Math.max(0, (oldAmountAll || 0) + addVal - removeVal);

            await updateLiveStock({
                variables: {
                    where: { id: editId },
                    data: {
                        amountAll: newAmountAll,
                        amount: _amount >= 0 ? _amount : 0,
                    }
                }
            })

            // If new price or new amount than more old data.  we well update stock!
            const stock = item?.stock
            let newStockData = {}
            if (price !== stock?.price) {
                newStockData = { price: price ? parseFloat(price.toString().replace(/,/g, '')) : 0 };
            }
            if (_amount > stock?.amount) {
                newStockData = { ...newStockData, amount: _amount >= 0 ? _amount : 0 };
            }
            if (!_.isEmpty(newStockData)) {
                await updateStock({
                    variables: {
                        where: { id: editStockId },
                        data: newStockData
                    }
                })
            }

            // Update live stock amount
            const _lSIndex = _.findIndex(liveStocks, { id: editId }); // Find the index of the object 
            if (_lSIndex < 0) return;

            const updatedLiveStock = _.cloneDeep(liveStocks); // Make a deep copy of the original array
            updatedLiveStock[_lSIndex] = {
                ...updatedLiveStock[_lSIndex],
                ...{
                    // amountAll: amountAll ? (parseFloat(amountAll.toString().replace(/,/g, '')) + oldAmountAll) : oldAmountAll,
                    amountAll: newAmountAll,
                    amount: _amount >= 0 ? _amount : 0,
                    stock: { ...updatedLiveStock[_lSIndex]?.stock, price: price ? parseFloat(price.toString().replace(/,/g, '')) : 0 }
                }
            };

            setLiveStocks(updatedLiveStock);
            handleSearch(textSearch);
            setEditId(null)
            setEditStockId(null)
            setPrice(null)
            setAmountAdd("")
            setAmountRemove("")
            setOldAmountAll(0)
            setAmount(0)
            setIsEditing(false)
            // fetchLiveStocks();
        } catch (error) {
            console.log("on edit live stock: ", error)
        }
    }

    const sortLiveStocks = (stocks, orderBy) => {
        const [field, direction] = orderBy.split('_');
        
        return [...stocks].sort((a, b) => {
            let aValue, bValue;
            
            switch (field) {
                case 'cfMessage':
                    aValue = a.cfMessage?.toLowerCase() || '';
                    bValue = b.cfMessage?.toLowerCase() || '';
                    break;
                case 'price':
                    aValue = parseFloat(a.stock?.price) || 0;
                    bValue = parseFloat(b.stock?.price) || 0;
                    break;
                case 'amount':
                    aValue = parseInt(a.amount) || 0;
                    bValue = parseInt(b.amount) || 0;
                    break;
                case 'createdAt':
                    aValue = new Date(a.createdAt);
                    bValue = new Date(b.createdAt);
                    break;
                case 'isPublished':
                    aValue = a.isPublished ? 1 : 0;
                    bValue = b.isPublished ? 1 : 0;
                    break;
                default:
                    return 0;
            }
            
            if (direction === 'ASC') {
                return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
            } else {
                return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
            }
        });
    };

    const handleSearch = (text) => {
        setTextSearch(text)
        // setCurrentPage(0)
        if (!text || text === "") {
            const sortedStocks = sortLiveStocks(liveStocks, orderBy);
            return setSearchLiveStocks(sortedStocks);
        }

        const filteredResults = liveStocks.filter((lStock) => {
            return lStock.cfMessage?.toLowerCase().includes(text.toLowerCase());
        });
        
        const sortedFilteredResults = sortLiveStocks(filteredResults, orderBy);
        setSearchLiveStocks(sortedFilteredResults);
    };


    const switchPublished = async (id, _published) => {
        try {
            const _updateLiveStock = await updateLiveStock({
                variables: {
                    where: { id },
                    data: {
                        isPublished: !_published
                    }
                }
            })
            if (_updateLiveStock?.data) {
                // Update live stock publi
                const _lSIndex = _.findIndex(liveStocks, { id }); // Find the index of the object 
                if (_lSIndex < 0) return;

                const updatedLiveStock = _.cloneDeep(liveStocks); // Make a deep copy of the original array
                updatedLiveStock[_lSIndex] = {
                    ...updatedLiveStock[_lSIndex],
                    ...{
                        isPublished: !_published
                    }
                };
                setLiveStocks(updatedLiveStock);
                // return fetchLiveStocks();
            }
        } catch (error) {
            console.log("error: ", error)
        }
    }

    const handlePageClick = (event) => {
        const newPage = event.selected;
        setCurrentPage(newPage);
    };

    const handleClearCacheLiveStockRedis = async ( ) => {
        try {
            // liveId from url
            const liveId = window.location.pathname.split('/').pop();
            await clearCacheLiveStockRedis({
                variables: {
                    liveId
                }
            })
            addToast("ເຄຼຍແຄຼສ ສຳເລັດ", {
                appearance: 'success',
                autoDismiss: true,
            });
        } catch (error) {
            console.log("Error in handleClearCacheLiveStockRedis: ", error)
            addToast("ເຄຼຍແຄຼສ ຜິດພາດ", {
                appearance: 'error',
                autoDismiss: true,
            });
        }
    }
 
    return (
        <div style={{ padding: 5, background: '#F5F5FA', display: 'flex', flexDirection: 'column', border: '1px solid #F5F5FA', borderRadius: 10, height: width > 700 ? "82vh" : "70vh" }}>
            <div style={{ 
                display: 'flex', 
                margin: width > 768 ? "8px 0px" : "5px 0px", 
                justifyContent: 'space-between', 
                flexWrap: 'wrap', 
                gap: width > 768 ? '8px' : '5px',
                alignItems: 'stretch'
            }}>
                <div style={{ 
                    display: 'flex', 
                    gap: width > 768 ? 8 : 5, 
                    flex: 1, 
                    minWidth: width > 768 ? '300px' : '250px', 
                    flexWrap: 'wrap',
                    alignItems: 'stretch'
                }}>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        border: '1px solid #E0E0E0', 
                        borderRadius: '8px', 
                        background: '#FFF', 
                        padding: width > 768 ? '8px 12px' : '6px 10px', 
                        flex: 1, 
                        minWidth: width > 768 ? '180px' : '150px',
                        height: width > 768 ? '40px' : '36px'
                    }}>
                        <FontAwesomeIcon 
                            style={{ marginRight: '8px', fontSize: '14px' }} 
                            color='#9E9E9E' 
                            icon={faSearch} 
                        />
                        <input
                            onChange={(e) => handleSearch(e.target.value)}
                            placeholder="ຄົ້ນຫາລະຫັດ CF"
                            style={{ 
                                border: 'none', 
                                outline: 'none', 
                                width: '100%',
                                fontSize: width > 768 ? '14px' : '13px',
                                background: 'transparent'
                            }} 
                        />
                    </div>
                    <Form.Select
                        value={orderBy}
                        onChange={(e) => setOrderBy(e.target.value)}
                        style={{ 
                            minWidth: width > 768 ? "160px" : "70px", 
                            maxWidth: width > 768 ? "200px" : "100px",
                            height: width > 768 ? '40px' : '36px',
                            fontSize: width > 768 ? '14px' : '13px',
                            border: '1px solid #E0E0E0',
                            borderRadius: '8px'
                        }}
                    >
                        <option value="cfMessage_ASC">CF (A-Z)</option>
                        <option value="cfMessage_DESC">CF (Z-A)</option>
                        <option value="price_ASC">ລາຄາ ↑</option>
                        <option value="price_DESC">ລາຄາ ↓</option>
                        <option value="amount_ASC">ຈຳນວນ ↑</option>
                        <option value="amount_DESC">ຈຳນວນ ↓</option>
                        <option value="createdAt_ASC">ວັນທີ່ ↑</option>
                        <option value="createdAt_DESC">ວັນທີ່ ↓</option>
                        <option value="isPublished_ASC">ປິດກ່ອນ</option>
                        <option value="isPublished_DESC">ເປີດກ່ອນ</option>
                    </Form.Select>
                    {/* // Clear cache stock live button */}
                    <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => {
                            handleClearCacheLiveStockRedis()
                        }}
                        disabled={clearCacheLoading}
                        loading={clearCacheLoading}
                        style={{
                            fontSize: width < 768 ? 11 : 13,
                            padding: width < 768 ? '4px 8px' : '6px 12px',
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                        }}
                    >
                        <FontAwesomeIcon icon={faSyncAlt} />{width < 768 ? '' : 'ເຄຼຍແຄຼສ'}
                    </Button>
                </div>
                <Button 
                    onClick={() => setShowAddStockModal(true)} 
                    style={{ 
                        border: 'none', 
                        background: COLOR_APP, 
                        fontWeight: '600', 
                        whiteSpace: 'nowrap', 
                        padding: width > 768 ? '8px 16px' : '6px 12px', 
                        margin: '0px', 
                        borderRadius: '8px',
                        minWidth: 'fit-content',
                        height: width > 768 ? '40px' : '36px',
                        fontSize: width > 768 ? '14px' : '13px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    + ເພີ່ມສິນຄ້າ
                </Button>
            </div>
            <div style={{ 
                color: COLOR_APP, 
                marginTop: 10, 
                fontSize: 18, 
                fontWeight: 'bold',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '8px'
            }}>
                <span>ສິນຄ້າ ({totalLiveStock <= 0 ? <Spinner size="sm" animation="border" /> : (searchLiveStocks ? searchLiveStocks?.length : totalLiveStock)})</span>
                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setShowAnalytics(!showAnalytics)}
                    style={{
                        fontSize: width < 768 ? 11 : 13,
                        padding: width < 768 ? '4px 8px' : '6px 12px',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                    }}
                >
                    {showAnalytics ? 'ເຊື່ອງລາຍງານ❗️' : '📈 ສະແດງລາຍງານ'}
                </Button>
            </div>
            
            {/* Comprehensive Analytics Section */}
            {showAnalytics && (() => {
                // const currentStocks = searchLiveStocks || liveStocks || [];
                
                return (
                    <div style={{ 
                        backgroundColor: '#f8f9fa', 
                        padding: width < 768 ? '8px' : '12px', 
                        borderRadius: '8px',
                        border: '1px solid #e9ecef',
                        marginTop: 8,
                        marginBottom: 8
                    }}>
                        {/* Summary Row */}
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            marginBottom: width < 768 ? '6px' : '8px',
                            flexWrap: 'wrap',
                            gap: '4px'
                        }}>
                            <div style={{ fontSize: width < 768 ? 12 : 14, fontWeight: 600, color: '#495057' }}>
                                📊 ລາຍງານສະຕ໊ອກ
                            </div>
                            <div style={{ fontSize: width < 768 ? 10 : 12, color: '#6c757d' }}>
                                ທັງໝົດ: {thousand(liveStocks?.length || 0)} ລາຍການ
                            </div>
                        </div>

                        {/* Stock & Price Summary */}
                        <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: '1fr 1fr 1fr', 
                            gap: width < 768 ? '6px' : '8px',
                            marginBottom: width < 768 ? '8px' : '10px'
                        }}>
                            <div style={{ textAlign: 'center', padding: width < 768 ? '4px' : '6px' }}>
                                <div style={{ fontSize: width < 768 ? 10 : 11, color: '#6c757d' }}>ສະຕ໊ອກທັງໝົດ</div>
                                <div style={{ fontSize: width < 768 ? 12 : 14, fontWeight: 600, color: '#007bff' }}>
                                    {thousand(liveStocks?.reduce((sum, item) => sum + (item?.amountAll || 0), 0) || 0)}
                                </div>
                            </div>
                            <div style={{ textAlign: 'center', padding: width < 768 ? '4px' : '6px' }}>
                                <div style={{ fontSize: width < 768 ? 10 : 11, color: '#6c757d' }}>ຂາຍແລ້ວ</div>
                                <div style={{ fontSize: width < 768 ? 12 : 14, fontWeight: 600, color: '#28a745' }}>
                                    {thousand(liveStocks?.reduce((sum, item) => sum + ((item?.amountAll || 0) - (item?.amount || 0)), 0) || 0)}
                                </div>
                            </div>
                            <div style={{ textAlign: 'center', padding: width < 768 ? '4px' : '6px' }}>
                                <div style={{ fontSize: width < 768 ? 10 : 11, color: '#6c757d' }}>ເຫຼືອ</div>
                                <div style={{ fontSize: width < 768 ? 12 : 14, fontWeight: 600, color: '#6c757d' }}>
                                    {thousand(liveStocks?.reduce((sum, item) => sum + (item?.amount || 0), 0) || 0)}
                                </div>
                            </div>
                        </div>

                        {/* Currency Breakdown */}
                        <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: width < 768 ? '1fr' : '1fr 1fr 1fr', 
                            gap: width < 768 ? '4px' : '6px'
                        }}>
                            {/* LAK */}
                            {(() => {
                                const lakStocks = liveStocks?.filter(item => item?.stock?.currency === "ກີບ" || item?.stock?.currency === "LAK") || [];
                                
                                if (lakStocks.length < 1) return null;
                                
                                const lakTotalPrice = lakStocks.reduce((sum, item) => sum + ((item?.stock?.price || 0) * (item?.amountAll || 0)), 0);
                                const lakSoldPrice = lakStocks.reduce((sum, item) => sum + ((item?.stock?.price || 0) * ((item?.amountAll || 0) - (item?.amount || 0))), 0);
                                const lakRemainingPrice = lakStocks.reduce((sum, item) => sum + ((item?.stock?.price || 0) * (item?.amount || 0)), 0);
                                
                                return (
                                    <div style={{ 
                                        backgroundColor: '#fff', 
                                        padding: width < 768 ? '6px' : '8px', 
                                        borderRadius: '6px',
                                        border: '1px solid #e9ecef'
                                    }}>
                                        <div style={{ 
                                            fontSize: width < 768 ? 10 : 11, 
                                            fontWeight: 600, 
                                            color: '#495057',
                                            marginBottom: '2px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}>
                                            <span>₭ ກີບ</span>
                                            <span style={{ fontSize: width < 768 ? 9 : 10, color: '#6c757d' }}>
                                                {lakStocks.length} ລາຍການ
                                            </span>
                                        </div>
                                        <div style={{ fontSize: width < 768 ? 9 : 10, lineHeight: 1.3 }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <span style={{ color: '#007bff' }}>ທັງໝົດ:</span>
                                                <span>{thousand(lakTotalPrice)}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <span style={{ color: '#28a745' }}>ຂາຍແລ້ວ:</span>
                                                <span>{thousand(lakSoldPrice)}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <span style={{ color: '#6c757d' }}>ເຫຼືອ:</span>
                                                <span>{thousand(lakRemainingPrice)}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })()}

                            {/* BAHT */}
                            {(() => {
                                const bahtStocks = liveStocks?.filter(item => item?.stock?.currency === "ບາດ" || item?.stock?.currency === "BAHT") || [];
                                
                                if (bahtStocks.length < 1) return null;
                                
                                const bahtTotalPrice = bahtStocks.reduce((sum, item) => sum + ((item?.stock?.price || 0) * (item?.amountAll || 0)), 0);
                                const bahtSoldPrice = bahtStocks.reduce((sum, item) => sum + ((item?.stock?.price || 0) * ((item?.amountAll || 0) - (item?.amount || 0))), 0);
                                const bahtRemainingPrice = bahtStocks.reduce((sum, item) => sum + ((item?.stock?.price || 0) * (item?.amount || 0)), 0);
                                
                                return (
                                    <div style={{ 
                                        backgroundColor: '#fff', 
                                        padding: width < 768 ? '6px' : '8px', 
                                        borderRadius: '6px',
                                        border: '1px solid #e9ecef'
                                    }}>
                                        <div style={{ 
                                            fontSize: width < 768 ? 10 : 11, 
                                            fontWeight: 600, 
                                            color: '#495057',
                                            marginBottom: '2px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}>
                                            <span>฿ ບາດ</span>
                                            <span style={{ fontSize: width < 768 ? 9 : 10, color: '#6c757d' }}>
                                                {bahtStocks.length} ລາຍການ
                                            </span>
                                        </div>
                                        <div style={{ fontSize: width < 768 ? 9 : 10, lineHeight: 1.3 }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <span style={{ color: '#007bff' }}>ທັງໝົດ:</span>
                                                <span>{thousand(bahtTotalPrice)}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <span style={{ color: '#28a745' }}>ຂາຍແລ້ວ:</span>
                                                <span>{thousand(bahtSoldPrice)}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <span style={{ color: '#6c757d' }}>ເຫຼືອ:</span>
                                                <span>{thousand(bahtRemainingPrice)}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })()}

                            {/* USD */}
                            {(() => {
                                const usdStocks = liveStocks?.filter(item => item?.stock?.currency === "ໂດລາ" || item?.stock?.currency === "USD") || [];
                                
                                if (usdStocks.length < 1) return null;
                                
                                const usdTotalPrice = usdStocks.reduce((sum, item) => sum + ((item?.stock?.price || 0) * (item?.amountAll || 0)), 0);
                                const usdSoldPrice = usdStocks.reduce((sum, item) => sum + ((item?.stock?.price || 0) * ((item?.amountAll || 0) - (item?.amount || 0))), 0);
                                const usdRemainingPrice = usdStocks.reduce((sum, item) => sum + ((item?.stock?.price || 0) * (item?.amount || 0)), 0);
                                
                                return (
                                    <div style={{ 
                                        backgroundColor: '#fff', 
                                        padding: width < 768 ? '6px' : '8px', 
                                        borderRadius: '6px',
                                        border: '1px solid #e9ecef'
                                    }}>
                                        <div style={{ 
                                            fontSize: width < 768 ? 10 : 11, 
                                            fontWeight: 600, 
                                            color: '#495057',
                                            marginBottom: '2px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}>
                                            <span>$ ໂດລາ</span>
                                            <span style={{ fontSize: width < 768 ? 9 : 10, color: '#6c757d' }}>
                                                {usdStocks.length} ລາຍການ
                                            </span>
                                        </div>
                                        <div style={{ fontSize: width < 768 ? 9 : 10, lineHeight: 1.3 }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <span style={{ color: '#007bff' }}>ທັງໝົດ:</span>
                                                <span>{thousand(usdTotalPrice)}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <span style={{ color: '#28a745' }}>ຂາຍແລ້ວ:</span>
                                                <span>{thousand(usdSoldPrice)}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <span style={{ color: '#6c757d' }}>ເຫຼືອ:</span>
                                                <span>{thousand(usdRemainingPrice)}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                );
            })()}


            {/* Header Row */}
            <div className="row mb-1" style={{ 
                whiteSpace: 'nowrap', 
                border: '1px solid #e0e0e0', 
                fontWeight: 'bold', 
                margin: "0", 
                padding: "6px 4px", 
                background: '#f8f9fa', 
                borderRadius: 4,
                fontSize: width < 768 ? 11 : 13
            }}>
                <div className="col-1" style={{ padding: '0 2px', fontSize: width < 768 ? 10 : 12 }}>ປິດ/ເປີດ</div>
                <div className="col-4" style={{ alignSelf: 'center', textAlign: 'center', padding: '0 2px' }}>ສິນຄ້າ</div>
                <div className="col-1" style={{ padding: '0 2px', alignSelf: 'center', textAlign: 'center' }}>ລະຫັດ</div>
                <div className="col-2" style={{ padding: '0 2px', alignSelf: 'center', textAlign: 'center' }}>ລາຄາ</div>
                <div className="col-2" style={{ padding: '0 2px', whiteSpace: 'nowrap', textAlign: 'center', alignSelf: 'center' }}>ຈ/ນ</div>
                <div className="col-2" style={{ padding: '0 2px', alignSelf: 'center', textAlign: 'center' }}>ຈັດການ</div>
            </div>

            {/* Stock List Container */}
            <div style={{ 
                overflow: 'auto', 
                maxHeight: width < 768 ? '60vh' : 'auto',
                border: '1px solid #e0e0e0',
                borderRadius: 4,
                background: '#fff'
            }}>
                {
                    (currentItems && currentItems.length > 0) && currentItems.map((lStock) => {
                        return <div key={lStock?.id} className="row" 
                            style={{ 
                                border: 'none',
                                borderBottom: '1px solid #f0f0f0',
                                margin: "0", 
                                padding: width < 768 ? '6px 4px' : '8px 4px',
                                color: lStock?.amount <= 0 ? 'white' : 'inherit',
                                background: lStock?.amount <= 0 ? '#dc3545' : (lStock?.amount > 0 && lStock?.amount <= 1 ? '#fff3cd' : '#fff'),
                                transition: 'background-color 0.2s ease',
                                minHeight: width < 768 ? 50 : 60,
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'nowrap',
                                overflow: 'hidden'
                            }}
                            >
                            {/* Switch Column */}
                            <div className="col-1" style={{ padding: '0 2px', alignSelf: 'center', display: 'flex', justifyContent: 'center' }}>
                                <Switch
                                    checked={lStock?.isPublished ?? false}
                                    onChange={() => switchPublished(lStock?.id, lStock?.isPublished)}
                                    onColor="#28a745"
                                    onHandleColor="#fff"
                                    handleDiameter={width < 768 ? 12 : 14}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 3px rgba(0, 0, 0, 0.3)"
                                    activeBoxShadow="0px 0px 1px 8px rgba(0, 0, 0, 0.1)"
                                    height={width < 768 ? 8 : 10}
                                    width={width < 768 ? 20 : 25}
                                    className="react-switch"
                                    id="material-switch"
                                />
                            </div>

                            {/* Product Column */}
                            <div className="col-3" style={{ 
                                display: 'flex', 
                                alignSelf: 'center', 
                                flexDirection: 'row',
                                padding: '0 2px',
                                gap: width < 768 ? 4 : 6,
                                minWidth: 0,
                                maxWidth: '100%',
                                overflow: 'hidden'
                            }}>
                                <img
                                    src={lStock?.stock?.image ? imageRender(lStock?.stock?.image) : "/images/noPhoto.png"}
                                    alt={lStock?.stock?.name}
                                    style={{ 
                                        borderRadius: 4, 
                                        width: width < 768 ? 35 : 40, 
                                        height: width < 768 ? 35 : 40,
                                        objectFit: 'cover',
                                        flexShrink: 0
                                    }}
                                />
                                <div style={{ 
                                    flex: 1, 
                                    minWidth: 0,
                                    maxWidth: `calc(100% - ${width < 768 ? 35 + 4 : 40 + 6}px)`,
                                    overflow: 'hidden'
                                }}>
                                    <Tooltip text={lStock?.stock?.name}>
                                        <div style={{ 
                                            overflow: "hidden", 
                                            textOverflow: "ellipsis", 
                                            whiteSpace: 'nowrap',
                                            fontSize: width < 768 ? 11 : 13,
                                            fontWeight: 500,
                                            lineHeight: 1.2,
                                            maxWidth: '100%'
                                        }}>
                                            {lStock?.stock?.name}
                                        </div>
                                    </Tooltip>
                                    {lStock?.stock?.optionValues?.length > 0 && (
                                        <div style={{ marginTop: 2 }}>
                                            {lStock?.stock?.optionValues?.slice(0, width < 768 ? 1 : 2).map((item, _index) => (
                                                <div key={_index} style={{ 
                                                    fontSize: width < 768 ? 9 : 10, 
                                                    color: '#666',
                                                    lineHeight: 1.1,
                                                    marginBottom: 1,
                                                    overflow: "hidden", 
                                                    textOverflow: "ellipsis", 
                                                    whiteSpace: 'nowrap',
                                                    maxWidth: '100%'
                                                }}>
                                                    {item?.name}: {item?.value}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Code Column */}
                            <div className="col-2" style={{ 
                                alignSelf: 'center', 
                                textAlign: 'center', 
                                padding: '0 1px',
                                minWidth: 0,
                                maxWidth: '100%',
                                overflow: 'visible'
                            }}>
                                <Tooltip text={lStock?.cfMessage}>
                                    <div style={{ 
                                        fontSize: width < 768 ? 9 : (lStock?.amount <= 0 ? 12 : 10),
                                        border: '1px solid #5357B6', 
                                        color: lStock?.amount <= 0 ? 'white' : '#5357B6',
                                        padding: '2px 4px', 
                                        borderRadius: 4,
                                        background: lStock?.amount <= 0 ? 'transparent' : '#f8f9ff',
                                        display: 'inline-block',
                                        wordWrap: 'break-word',
                                        whiteSpace: 'normal',
                                        lineHeight: 1.2
                                    }}>
                                        {lStock?.cfMessage}
                                    </div>
                                </Tooltip>
                            </div>

                            {/* Price Column */}
                            <div className="col-2" style={{ 
                                padding: '0 2px', 
                                alignSelf: 'center', 
                                textAlign: 'center',
                                minWidth: 0,
                                maxWidth: '100%',
                                overflow: 'visible'
                            }}>
                                {isEditing && editId == lStock?.id ? 
                                    <NumberFormat
                                        name="price"
                                        className="form-control form-control-sm"
                                        onChange={(e) => setPrice(e?.target?.value ?? "")}
                                        value={price ?? ""}
                                        placeholder="0"
                                        thousandSeparator={true} 
                                        prefix={''}
                                        style={{ fontSize: width < 768 ? 11 : 13 }}
                                    />
                                    :
                                    <div style={{ 
                                        fontSize: width < 768 ? 10 : 12, 
                                        fontWeight: 500,
                                        wordWrap: 'break-word',
                                        whiteSpace: 'normal',
                                        lineHeight: 1.2
                                    }}>
                                        {lStock?.stock?.price ? thousand(lStock?.stock?.price) + " " + convertCurrency(lStock?.stock?.currency) : "0"}
                                    </div>
                                }
                            </div>

                            {/* Amount Column */}
                            <div className="col-2" style={{ 
                                padding: '0 2px', 
                                alignSelf: 'center', 
                                textAlign: 'center',
                                minWidth: 0,
                                maxWidth: '100%',
                                overflow: 'hidden'
                            }}>
                                {isEditing && editId == lStock?.id ? 
                                    <div style={{display:"flex", flexDirection:"column", gap:4}}>
                                        <NumberFormat
                                        name="amountAdd"
                                        className="form-control form-control-sm"
                                        onChange={(e) => setAmountAdd(e?.target?.value ?? "")}
                                        value={amountAdd ?? ""}
                                        placeholder="ເພີ່ມຈຳນວນ"
                                        thousandSeparator={true} 
                                        prefix={''}
                                        disabled={amountRemove !== ""}
                                        style={{ fontSize: width < 768 ? 11 : 13 }}
                                        />
                                        <NumberFormat
                                        name="amountRemove"
                                        className="form-control form-control-sm"
                                        onChange={(e) => setAmountRemove(e?.target?.value ?? "")}
                                        value={amountRemove ?? ""}
                                        placeholder="ລົບຈຳນວນ"
                                        thousandSeparator={true} 
                                        prefix={''}
                                        disabled={amountAdd !== ""}
                                        style={{ fontSize: width < 768 ? 11 : 13 }}
                                        />
                                    </div>
                                    :
                                    <div style={{ 
                                        fontSize: width < 768 ? 10 : 12, 
                                        fontWeight: 500,
                                        color: lStock?.amount <= 0 ? 'inherit' : (lStock?.amount <= 1 ? '#856404' : '#28a745'),
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        {lStock?.amount}/{lStock?.amountAll}
                                    </div>
                                }
                            </div>

                            {/* Actions Column */}
                            <div className="col-2" style={{ padding: '0 2px', alignSelf: 'center', textAlign: 'center' }}>
                                <div style={{ 
                                    display: 'flex', 
                                    flexDirection: 'row', 
                                    alignItems: "center", 
                                    justifyContent: "center",
                                    gap: width < 768 ? 8 : 12
                                }}>
                                    {(!isEditing || editId != lStock?.id) && 
                                        <FontAwesomeIcon 
                                            onClick={() => onEditing(lStock.id, lStock?.stock?.id, lStock?.stock?.price, lStock?.amountAll, lStock?.amount)} 
                                            icon={faEdit} 
                                            style={{ 
                                                color: COLOR_APP, 
                                                fontSize: width < 768 ? 14 : 16, 
                                                cursor: "pointer",
                                                transition: 'color 0.2s ease'
                                            }} 
                                        />
                                    }
                                    {isEditing && editId == lStock?.id && 
                                        <>
                                            <FontAwesomeIcon 
                                                onClick={() => onEditLiveStock(lStock)} 
                                                icon={faCheckCircle} 
                                                style={{ 
                                                    color: "#28a745", 
                                                    fontSize: width < 768 ? 14 : 16, 
                                                    cursor: "pointer",
                                                    transition: 'color 0.2s ease'
                                                }} 
                                            />
                                            <FontAwesomeIcon 
                                                onClick={() => onCancel()} 
                                                icon={faTimesCircle} 
                                                style={{ 
                                                    color: "#000000", 
                                                    fontSize: width < 768 ? 14 : 16, 
                                                    cursor: "pointer",
                                                    transition: 'color 0.2s ease'
                                                }} 
                                            />
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    })
                }
            </div>
            <ReactPaginate
                previousLabel={<MdArrowBackIos />}
                onPageChange={handlePageClick}
                breakLabel="..."
                pageRangeDisplayed={2}
                pageCount={Math.ceil((searchLiveStocks ? searchLiveStocks?.length : totalLiveStock) / _limit)}
                marginPagesDisplayed={2}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
                forcePage={currentPage}
                nextLabel={<MdArrowForwardIos />}
            />
            <AddStockModal 
                fetchLiveStocks={fetchLiveStocks} 
                showAddStockModal={showAddStockModal} 
                setShowAddStockModal={setShowAddStockModal} 
                liveStocks={liveStocks} 
                setLiveStocks={setLiveStocks} 
                seTotalLiveStock={seTotalLiveStock}
                getStocks={getStocks}
                stockData={stockData}
                stockLoading={stockLoading}
            />
        </div>
    );
}

export default StockLiveScreen;
